export default __webpack_public_path__ + "static/media/ic-camera.2b44feed.svg";